import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadListLogComponent } from './log.component';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';


@NgModule({
  declarations: [
    FileUploadListLogComponent,
  ],
  imports: [
    CommonModule,
    VirtualScrollerModule,

  ],
  exports:[FileUploadListLogComponent],
})
export class FileUploadListLogModule { }
